// extracted by mini-css-extract-plugin
module.exports = {"full-size":"ComEvent-b0e59417-scss"};